import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import WarningModal from "./WarningModal";
import { Box, Typography } from "@mui/material";

const SpecialAssignmentConfirmationModal = ({
  open,
  onClose,
  onSubmit,
  employees
}) => {
  const { t } = useTranslation();
  return (
    <WarningModal
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      showCloseIcon
      warningMessage={
        <Box>
          <Typography>
            {t("specialAssignments.confirmationModalText")}
          </Typography>
          {employees.map(emp => (
            <Typography variant="subtitle2" key={emp.id}>
              {emp.name}
            </Typography>
          ))}
        </Box>
      }
    />
  );
};

SpecialAssignmentConfirmationModal.propTypes = {
  open: PropTypes.boolean,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
      name: PropTypes.string
    })
  )
};

export default SpecialAssignmentConfirmationModal;
